"use client";

import Link from "next/link";
import StickyBox from "react-sticky-box";
import { createExcerpt } from "@/lib/blog/content";

type RelatedPost = {
  id: string;
  slug: string;
  title: string;
  image_url: string | null;
  meta_description: string | null;
  content_markdown: string;
  published_at: string | Date;
};

type BlogRelatedSidebarProps = {
  posts: RelatedPost[];
};

const TOP_OFFSET_PX = 132;
const BOTTOM_OFFSET_PX = 24;

export function BlogRelatedSidebar({ posts }: BlogRelatedSidebarProps) {
  // if (posts.length === 0) {
  //   return null;
  // }

  return (
    <StickyBox
      offsetTop={TOP_OFFSET_PX}
      offsetBottom={BOTTOM_OFFSET_PX}
      style={{ alignSelf: "flex-start" }}
      className="hidden lg:block lg:w-[320px] lg:shrink-0"
      aria-label="Related blog posts"
    >
      <div className="rounded-xl border bg-foreground/5 p-5">
        <h3 className="font-serif text-xl font-light tracking-tight">
          Other Articles You Might Be Interested In
        </h3>
        <div className="mt-4 space-y-4">
          {posts.map((item) => (
            <article
              key={item.id}
              className="border-t pt-4 first:border-t-0 first:pt-0"
            >
              {item.image_url ? (
                // eslint-disable-next-line @next/next/no-img-element
                <img
                  src={item.image_url}
                  alt={item.title}
                  className="mb-3 h-36 w-full rounded-lg border object-cover"
                  loading="lazy"
                />
              ) : null}
              <p className="text-xs text-muted-foreground">
                {new Intl.DateTimeFormat("en-US", {
                  dateStyle: "medium",
                }).format(
                  typeof item.published_at === "string"
                    ? new Date(item.published_at)
                    : item.published_at,
                )}
              </p>
              <Link
                href={`/blog/${item.slug}`}
                className="mt-1 block text-sm font-medium leading-6 hover:text-primary"
              >
                {item.title}
              </Link>
              <p className="mt-2 line-clamp-2 text-sm text-muted-foreground">
                {createExcerpt(
                  item.meta_description ?? item.content_markdown,
                  110,
                )}
              </p>
            </article>
          ))}
        </div>
      </div>
    </StickyBox>
  );
}
